import { render, staticRenderFns } from "./uploader-by-paste.vue?vue&type=template&id=6a8c19b0&scoped=true&"
import script from "./uploader-by-paste.vue?vue&type=script&lang=js&"
export * from "./uploader-by-paste.vue?vue&type=script&lang=js&"
import style1 from "./uploader-by-paste.vue?vue&type=style&index=1&id=6a8c19b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c19b0",
  null
  
)

export default component.exports